module.exports = __webpack_public_path__ + "static/img/right-top-row-5.5b647fc2.png";